// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"b212f20f","842":"24ce694e"}[chunkId] + ".chunk.js";
};